module.exports = __webpack_public_path__ + "static/media/hold-syringe-like-dart-with-text.902c4d61.svg";